import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AppRoutingModules} from './app-routing.modules';
import {Ng2Webstorage} from 'ngx-webstorage';
import {ReactiveFormsModule} from '@angular/forms';
import {UserService} from './core/api/user/client.service';
import {AuthClientHelper} from './core/helpers/auth/auth-client.helper';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {TruncatePipe} from './core/pipes/truncate/truncate.pipe';
import {NgUploaderModule} from 'ngx-uploader';
import {ImageHelper} from './core/helpers/image/image.helper';
import {SpinnerHelper} from './core/helpers/spinner/spinner.helper';
import {registerLocaleData} from '@angular/common';
import localePT from '@angular/common/locales/pt';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ResourceModule} from '@ngx-resource/handler-ngx-http';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BaseService} from './core/api/base.service';
import {ModalModule} from 'ngx-bootstrap/modal';
import {GasService} from './core/api/gas-station/client.service';
import {CitiesService} from './core/api/cities/client.service';
import {SelectModule} from 'ng-select';
import {SharedModule} from './shared/shared.module';

registerLocaleData(localePT);

@NgModule({
    declarations: [
        TruncatePipe,
        /** Components **/
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        Ng2Webstorage.forRoot({
            prefix: 'project_name'
        }),
        ReactiveFormsModule,
        HttpClientModule,
        NgxDatatableModule,
        NgUploaderModule,
        SelectModule,
        ResourceModule.forRoot(),
        ModalModule.forRoot(),
        /** Routes **/
        AppRoutingModules,
        SharedModule
    ],
    providers: [
        UserService,
        AuthClientHelper,
        GasService,
        CitiesService,
        ImageHelper,
        SpinnerHelper,
        {provide: LOCALE_ID, useValue: 'pt'},
        {provide: HTTP_INTERCEPTORS, useClass: BaseService, multi: true}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts